import { FileUploadInput } from '@avanta/shared/components/FileUploadInput';
import { Text } from '@avanta/shared/components/Text';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { DOCUMENT_CATEGORIES } from 'constants/common';
import { StepSection } from 'pages/AppointmentsReserve/components/ui/StepSection';
import { type AppointmentsReserveFormData } from 'pages/AppointmentsReserve/types';

const SESSION_DOCUMENT_ACCEPT = {
  'application/pdf': ['.pdf'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
};

const SESSION_DOCUMENT_MAX_SIZE = 10 * 1024 * 1024;

export const Documents = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { setValue } = useFormContext<AppointmentsReserveFormData>();

  const handleUpload = (file: File | null): void => {
    if (!file) return;
    setValue('document', {
      file,
      category: DOCUMENT_CATEGORIES.REPORT,
    });
  };

  const docsLabel = (
    <Trans
      ns={LOCIZE_NS.APPOINTMENTS}
      i18nKey="AppointmentsReserve.Steps.confirmation.documents.label"
      components={{
        span: <Text tag="span" variant="text-sm-regular" className="text-gray-400" />,
      }}
    />
  );
  return (
    <StepSection
      title={docsLabel}
      className="flex flex-col gap-2"
      containerClassName="gap-2 mt-6 w-146"
    >
      <Text variant="text-sm-regular" className="text-denim-800">
        {t('AppointmentsReserve.Steps.confirmation.documents.description')}
      </Text>
      <FileUploadInput
        accept={SESSION_DOCUMENT_ACCEPT}
        maxSize={SESSION_DOCUMENT_MAX_SIZE}
        dropText={t('AppointmentsReserve.Steps.confirmation.documents.dropText')}
        selectText={t('AppointmentsReserve.Steps.confirmation.documents.selectText')}
        helperText={t('AppointmentsReserve.Steps.confirmation.documents.helperText')}
        onChange={handleUpload}
      />
    </StepSection>
  );
};
